import React, { createContext, useCallback, useContext, useState } from "react";

const AuthContext = createContext(null);

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(false);
    const [userId, setUserId] = useState(0);
    const [isLoading, setIsLoading] = useState(true);
    const [accountType, setAccountType] = useState(null);

    const LogIn = useCallback((logInUserId, logInAccountType) => {
        setUser(true);
        setUserId(logInUserId);
        setAccountType(logInAccountType);
    }, []);

    const LogOut = useCallback(() => {
        setUser(false);
        setUserId(0);
        setAccountType(false);
    }, []);

    return (
        <AuthContext.Provider value={{ user, LogIn, LogOut, isLoading, setIsLoading, userId, accountType }}>
            {children}
        </AuthContext.Provider>
    );
};